(function() {
  var threshold = 150000;
  var initialized = false;

  function updateDrawerProgress() {
    var card = document.getElementById('drawerProgressCard');
    if (!card) return;

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var bar       = document.getElementById('drawerProgressBarFill');
        var messageEl = document.getElementById('drawerProgressMessage');
        var pctEl     = document.getElementById('drawerProgressPercentage');
        var giftEl    = document.getElementById('drawerGiftIcon');

        if (!bar || !messageEl) return;

        var cartTotal    = cart.total_price / 100;
        var percentage   = Math.min((cartTotal / threshold) * 100, 100);
        var amountNeeded = Math.max(threshold - cartTotal, 0);
        var isUnlocked   = percentage >= 100;

        var formatter = new Intl.NumberFormat('es-CO', {
          style: 'currency',
          currency: 'COP',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });

        bar.style.width = percentage + '%';
        bar.className = 'dp-bar-fill' + (isUnlocked ? ' is-complete' : '');

        if (giftEl) {
          giftEl.style.left = '100%';
          giftEl.className = 'dp-gift' + (isUnlocked ? ' is-complete' : '');
        }

        if (pctEl) {
          pctEl.textContent = Math.round(percentage) + '%';
          pctEl.className = 'dp-pct' + (isUnlocked ? ' is-complete' : '');
        }

        if (isUnlocked) {
          messageEl.className = 'dp-message is-complete';
          messageEl.innerHTML = 'Felicitaciones! Tu pedido tiene <strong>envio gratis</strong>';
        } else {
          messageEl.className = 'dp-message';
          messageEl.innerHTML = 'Agrega <strong id="drawerAmountNeeded">' + formatter.format(amountNeeded) + '</strong> mas para obtener envio gratis';
        }
      })
      .catch(function(err) { console.error('Drawer progress error:', err); });
  }

  var originalFetch = window.fetch;
  window.fetch = function() {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
    var result = originalFetch.apply(this, args);

    if (url.includes('/cart/add') || url.includes('cart_add_url')) {
      result.then(function(response) {
        if (response.ok) {
          setTimeout(function() {
            var cartDrawerForm = document.querySelector('sht-cart-drwr-frm');
            if (!cartDrawerForm || typeof cartDrawerForm.renderContents !== 'function') return;
            var drawerSection = document.querySelector('sht-cart-drwr');
            if (!drawerSection || typeof drawerSection.getSectionsToRender !== 'function') return;
            var sections = drawerSection.getSectionsToRender().map(function(s) { return s.id; });
            if (!sections.length) return;
            fetch(window.routes.cart_update_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ sections: sections, sections_url: window.location.pathname })
            })
            .then(function(r) { return r.json(); })
            .then(function(response) {
              cartDrawerForm.renderContents(response);
              setTimeout(updateDrawerProgress, 400);
            })
            .catch(function(err) { console.error('Drawer refresh error:', err); });
          }, 600);
        }
        return response;
      }).catch(function() {});
    }

    return result;
  };

  function init() {
    if (initialized) return;
    initialized = true;
    document.addEventListener('cart:updated', function() {
      setTimeout(updateDrawerProgress, 400);
    });
    setInterval(updateDrawerProgress, 800);
    updateDrawerProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
